// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".occupation-detail[data-v-49304133]{grid-gap:1.5rem;gap:1.5rem}.skills[data-v-49304133]{grid-gap:.5rem;gap:.5rem}.chips-container[data-v-49304133]{display:flex;grid-gap:1rem;gap:1rem;flex-wrap:wrap;max-height:300px;overflow-y:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
